import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, LICENSE } from '../../Server'
import axios from 'axios';
import $ from 'jquery'
import swal from 'sweetalert';

class ListUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            creatingCadmin: false,
            Lists: [],
            message: ""
        }
    }

    componentDidMount() {
        this.getTotalUser()
        $('[data-toggle="tooltip"]').tooltip();
        this.dataByLicense();
    }
    dataByLicense = () => {
        if (LICENSE.application_Dashboard) {
            this.setState(this.state)
        } else {
            setTimeout(() => {
                this.dataByLicense()
            }, 1000)
        }
    }
    getTotalUser = () => {
        var data = {
            s_id: ud.main_id,
            user_id: "",
            user_type: ud.usertype
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.usersList) {
                        _this.setState({ Lists: response.data.usersList, message: "No Record Found." });
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalUser();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                logo: reader.result
            });

        };
    }


    createUser = () => {
        window.location.href = "/create/user"
    }
    viewUser = (list) => {
        sessionStorage.setItem("User_Info", JSON.stringify(Object.assign(list, { user_action: "view" })))
        window.location.href = "/create/edituser"
    }
    editUser = (list) => {
        sessionStorage.setItem("User_Info", JSON.stringify(Object.assign(list, { user_action: "edit" })))
        window.location.href = "/create/edituser"
    }
    statusChange = (list) => {
        var data = {
            name: list.name,
            phone: list.phone,

            status: list.mainStatus == 1 ? 0 : 1,
            usertype: list.user_type === "SME" ? 1 : 2,
            address: list.address,
            id: list.login_id,
            new_profile: "",
            old_profile: list.profile,
            city: list.city,
            state: list.state,
            zip: list.zip,
            designation: list.designation,
            uniqueID: list.uniqueID,
            main_status: 1,
            user_update_status: {
                name: "0",
                phone: "0",
                usertype: "0",
                profile: "0",
                address: "0",
                city: "0",
                state: "0",
                zip: "0",
                types: "0"
            }
        }
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/create/user_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal(response.data.message)
                        _this.getTotalUser();
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.statusChange(list);
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    render() {
        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h3 className="xp-page-title">Users List</h3>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item">User List</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="xp-contentbar p-30">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            {LICENSE.organizationManagement ?
                                LICENSE.organizationManagement.total_users == "UNLIMITED" ?
                                    <button className="btn btn-primary btn-lg" title="Create new" onClick={this.createUser}><i className="mdi mdi-plus mr-2"></i>Create User</button>
                                    :
                                    Number(LICENSE.organizationManagement.total_users) - LICENSE.organizationManagement.total_users_usage <= 0 ?
                                        <button className="btn btn-primary btn-lg" data-toggle="tooltip" title="No User Remaining" disabled><i className="mdi mdi-plus mr-2"></i>Create User</button>
                                        :
                                        <button className="btn btn-primary btn-lg" title="Create new" onClick={this.createUser}><i className="mdi mdi-plus mr-2"></i>Create User</button>
                                :
                                null
                            }
                        </div>
                        <div className="col-md-4 offset-md-4">
                            <form>
                                <div className="searchlist">
                                    <i className="fa fa-search"></i>
                                    <input type="text" className="form-control" placeholder="Search..." />
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card m-b-30">
                                <div class="card-header bg-white dv-center space-between">
                                    <h5 class="card-title text-black mb-0">Users List</h5>
                                </div>

                                <div class="card-body">
                                    <div class="table-responsive">
                                        {this.state.Lists.length === 0 ?
                                            this.state.message === "" ?

                                                // loader
                                                <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                                // loader-end
                                                :
                                                <div className="message-no-record"> {this.state.message} </div>

                                            : null}
                                        <table class="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" style={{ width: "5%" }}>S.No.</th>
                                                    <th>User Name</th>
                                                    <th>Email ID</th>
                                                    <th className="text-center">Contact no.</th>
                                                    <th className="text-center">User Type</th>
                                                    <th className="text-center">Active/Inactive</th>
                                                    <th className="text-center">Preview/Edit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.Lists.map((list, index) =>
                                                    <tr>
                                                        <td className="text-center"><strong>{index + 1}.</strong></td>
                                                        <td>{list.name}</td>
                                                        <td>{list.email}</td>
                                                        <td className="text-center">{list.phone}</td>
                                                        <td className="text-center">{list.user_type == "SME" ? <span class="badge badge-warning text-dark btn-xs"><strong>{list.user_type}</strong></span> : <span class="badge badge-info btn-xs"><strong>{list.user_type}</strong></span>}</td>
                                                        <td className="text-center">
                                                            <label class="label-switch switch-success">
                                                                <input type="checkbox" class="switch switch-bootstrap status" onChange={() => this.statusChange(list)} checked={list.mainStatus == 1} name="status" id="status" value="1" />
                                                                <span class="lable"></span></label>
                                                        </td>
                                                        <td className="text-center">
                                                            <div class="tabledit-toolbar btn-toolbar" style={{ margin: "0 auto", display: "block" }}>
                                                                <div class="btn-group btn-group-sm">
                                                                    <button className="btn btn-info btn-xs" onClick={() => this.viewUser(list)} data-toggle="tooltip" title="Preview"> <i className="mdi mdi-eye" ></i></button>
                                                                    <button className="btn btn-secondary btn-xs" data-toggle="tooltip" onClick={() => this.editUser(list)} title="Edit"> <i className="mdi mdi-pencil"></i></button>
                                                                    {/* <button className="btn btn-danger btn-xs" data-toggle="tooltip" title="Delete"> <i className="mdi mdi-trash-can-outline"></i></button> */}

                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        )
    }
}
export default ListUsers

